export const CURRENCY_CODES = [
  "UAH",
  "USD",
  "EUR",
  "GBP",
  "PLN",
  "AUD",
  "CAD",
  "CHF",
  "CNY",
  "JPY",
] as const;

export type CurrencyCode = (typeof CURRENCY_CODES)[number];

export const DEFAULT_CURRENCY_CODE: CurrencyCode = "UAH";

export const CURRENCY_OPTIONS: Array<{ value: CurrencyCode; label: string }> = CURRENCY_CODES.map(
  (code) => ({ value: code, label: code })
);
